import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useRef, useState } from "react";
import { PhoneNumberAuthentication } from "../../../services/accountService";
import NiceModal from "@ebay/nice-modal-react";
import { setSignupData } from "../../../redux/signup";
import Loader from "react-loader-spinner";
import { GACategoryName, GAEventNames, GAUniqueEventIds, GenderType } from "../../../helpers/Enums";
import { LOGIN } from "../../../navigation/Constants";
import { Link } from "react-router-dom";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const PhoneVerficationSms = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 3032)).pop()!;
    const [errors, setErrors] = useState<any>({});
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [enableFormButton, setEnableFormButton] = useState<boolean>(false);
    const [isEnterPhone, setIsEnterPhone] = useState<boolean>(true);
    const [smsCodeInput, setSmsCodeInput] = useState<string>("");
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const smsCode = useRef({});



    // const [codenumberOne, setCodenumberOne] = useState<string>("");
    // const [codenumberTwo, setCodenumberTwo] = useState<string>("");
    // const [codenumberThree, setCodenumberThree] = useState<string>("");
    // const [codenumberFour, setCodenumberFour] = useState<string>("");


    const setMemberPhoneNumber = (phoneNumber: string) => {
        setPhoneNumber(phoneNumber);
        if (phoneNumber === "") {
            setEnableFormButton(false);
        } else {
            setEnableFormButton(true);
        }

    }

    const getVerifyCode = async (phoneNumber: string) => {
        try {
            return await PhoneNumberAuthentication(phoneNumber);
        } catch (err) {
            console.dir(err)
            return err;
        }
    };

    const validateFormPhoneNumber = () => {
        let isvalid = true;
        let errors: any = {};
        if (phoneNumber.length !== 10 || !RegExp('\\d{10}').test(phoneNumber)) {
            errors["phoneNumber"] = "נראה שיש טעות במספר. המספר צריך להיות בן 10 ספרות, בלי רווחים או מקפים";
            isvalid = false;
        }
        setErrors(errors);
        return isvalid;
    };

    const handlePhoneSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (validateFormPhoneNumber()) {
            setShowLoader(true);
            const { data, status }: any = await getVerifyCode(phoneNumber);

            if (data === "Phone number exists") {
                NiceModal.show("action_modal", {
                    onNext: () => NiceModal.hide("action_modal"),
                    headerTitle: "",
                    contentTitle: register.genderId === GenderType.MALE ? "מספר הטלפון קיים אצלנו, נראה שאתה כבר חבר בשושק'ה" : "מספר הטלפון קיים אצלנו, נראה שאת כבר חברה בשושק'ה ",
                    seconderyButtonText: "",
                    primaryButtonText: "אישור",
                    showCloseButton: true,
                    showSeconderyButton: false
                });
            } else if (status === 200) {

                smsCode.current = data;
                setIsEnterPhone(false);
            } else {
                NiceModal.show("action_modal", {
                    onNext: () => NiceModal.hide("action_modal"),
                    headerTitle: "שגיאה לא צפויה",
                    contentTitle: "לא ניתן היה להשלים את תהליך האימות",
                    seconderyButtonText: "",
                    primaryButtonText: "אישור",
                    showCloseButton: true,
                    showSeconderyButton: false
                });
            }
            setShowLoader(false);
        }
    };


    const setSmsCodeInputForm = (code: string) => {
        if (code === "") {
            setErrors({});
        }
        setSmsCodeInput(code);
    }


    const resentSmsCode = async () => {
        try {

            const { data, status }: any = await getVerifyCode(phoneNumber);

            if (status === 200) {
                smsCode.current = data;
                NiceModal.show("action_modal", {
                    onNext: () => NiceModal.hide("action_modal"),
                    headerTitle: "אימות טלפון",
                    contentTitle: "הודעת sms נשלחה שוב",
                    seconderyButtonText: "",
                    primaryButtonText: "אישור",
                    showCloseButton: true,
                    showSeconderyButton: false
                });
            }
            else {
                NiceModal.show("action_modal", {
                    onNext: () => NiceModal.hide("action_modal"),
                    headerTitle: "שגיאה לא צפויה",
                    contentTitle: "לא ניתן היה לשלוח קוד אימות חדש",
                    seconderyButtonText: "",
                    primaryButtonText: "אישור",
                    showCloseButton: true,
                    showSeconderyButton: false
                });
            }

        } catch (err) {
            console.log(err)
            NiceModal.show("action_modal", {
                onNext: () => NiceModal.hide("action_modal"),
                headerTitle: "שגיאה לא צפויה",
                contentTitle: "לא ניתן היה לשלוח קוד אימות חדש",
                seconderyButtonText: "",
                primaryButtonText: "אישור",
                showCloseButton: true,
                showSeconderyButton: false
            });
        }
    }

    const handleSubmitSms = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (smsCode.current.toString() === smsCodeInput) {
            register.phoneNumber = phoneNumber;
            dispatch(setSignupData(register));
            props.next();

            recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 5", "אישור מספר טלפון", GAUniqueEventIds.APP_SIGNUP)

        } else {
            setErrors((errors: any) => ({ ...errors, "sms_code_error": register.genderId === GenderType.MALE ? "הקוד שהקלדתה שגוי, שננסה שוב?" : "הקוד שהקלדת שגוי, שננסה שוב?" }));
        }
    };


    const phoneNumberForm = () => {
        return (
            <div className="content_sec wf-section">
                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{question.question}</h2>
                    <div>{question.questionSubTitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handlePhoneSubmit}>
                        <div className="form_field_content login">
                            <div className="field_block">
                                <input autoComplete="off" type='tel' name="phoneNumber" value={phoneNumber} placeholder="מספר הנייד, ללא מקף" onChange={e => setMemberPhoneNumber(e.target.value)} maxLength={10} className="txt_field tel w-input" />
                                <div style={{ display: errors && errors["phoneNumber"] ? "contents" : "block" }} className="form_allert">{errors["phoneNumber"]}</div>
                                <br />
                            </div>
                            {showLoader
                                ? <button disabled={true} className="button_full w-button">
                                    <Loader
                                        type="Oval"
                                        color="white"
                                        height={22}
                                        width={30}
                                    />
                                </button>
                                :
                                <>
                                    <input autoComplete="off" disabled={!enableFormButton} type="submit" value={question.buttonText} data-wait="" className={enableFormButton ? "button_full w-button" : "button_full inactive  w-button"}></input>
                                </>
                            }
                        </div>
                    </form>
                </div>


                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <Link to={LOGIN} style={{ textDecoration: 'underline' }}>כניסה לחברים רשומים</Link>
                </div>
            </div>
        )
    }




    const smsVerficationForm = () => {
        return (
            <div className="content_sec wf-section">
                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">שלחנו לך קוד לנייד</h2>
                    <div>שלחנו הודעת sms עם קוד האימות למספר {phoneNumber} </div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmitSms}>
                        <div className="form_field_content login">
                            <div className="field_block">
                                <input autoComplete="off" type='tel' name="sms_code" value={smsCodeInput} placeholder="המספר שהתקבל לנייד" onChange={e => setSmsCodeInputForm(e.target.value)} maxLength={4} className="txt_field w-input" />
                                <div className="form_allert" style={{ display: errors && errors["sms_code_error"] ? "contents" : "block", fontSize: '1.2rem', fontWeight: "bold" }}>{errors["sms_code_error"]}</div>
                                <br />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <input typeof="text" autoComplete="one-time-code" type="submit" value="אימות" data-wait="" className="button_full w-button"></input>
                                <a href="#" className="send_again" style={{ fontSize: '1rem', margin: '20px auto' }} onClick={resentSmsCode}>
                                    לא קיבלתי, שלחו שוב
                                </a>
                            </div>
                        </div>

                    </form>
                </div>

                {/* <div className="login_sec w-form signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">שלחנו לך קוד לנייד</h2>
                    <div>שלחנו הודעת sms עם קוד האימות למספר {phoneNumber} </div>
                    <form onSubmit={handleSubmitSms} >
                        <div style={{ display: errors && errors["sms_code_error"] ? "contents" : "block" }} className="form_allert">{errors["sms_code_error"]}</div>

                        <div style={{ direction: "ltr" }} className="field_quatro_group">
                            <div className="field_block quatro">
                                <input autoComplete="off" name="codenumber-1" onFocus={() => setCodenumberOne('')} type="tel" value={codenumberOne} onChange={e => handleChange(e, setCodenumberOne)} maxLength={1} className="txt_field w-input" />
                            </div>
                            <div className="field_block quatro">
                                <input autoComplete="off" name="codenumber-2" onFocus={() => setCodenumberTwo('')} type="tel" value={codenumberTwo} onChange={e => handleChange(e, setCodenumberTwo)} maxLength={1} className="txt_field w-input" />
                            </div>
                            <div className="field_block quatro">
                                <input autoComplete="off" name="codenumber-3" onFocus={() => setCodenumberThree('')} type="tel" value={codenumberThree} onChange={e => handleChange(e, setCodenumberThree)} maxLength={1} className="txt_field w-input" />
                            </div>
                            <div className="field_block quatro">
                                <input autoComplete="off" name="codenumber-4" onFocus={() => setCodenumberFour('')} type="tel" value={codenumberFour} onChange={e => handleChange(e, setCodenumberFour)} maxLength={1} className="txt_field w-input" />
                            </div>
                            <br />
                            <br />
                            <br />

                            <input autoComplete="off" disabled={!verfiySmsButtonEnabled} type="submit" value="המשך" data-wait="" className={verfiySmsButtonEnabled ? "button_full w-button" : "button_full inactive  w-button"}></input>
                        </div>
                        <br />

                        <a href="#" className="send_again" style={{ fontSize: '1rem', margin: '20px auto' }} onClick={resentSmsCode}>
                            לא קיבלתי, שלחו שוב
                        </a>

                    </form>

                </div> */}
            </div>
        )
    }



    return (
        <>
            {isEnterPhone ? phoneNumberForm() : smsVerficationForm()}
        </>
    )
}

export default PhoneVerficationSms;

